import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  useEffect(() => {
    document.title = "Page not found | Meadowlark Land Trust";
    let robots = document.head.querySelector<HTMLMetaElement>('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.name = "robots";
      document.head.appendChild(robots);
    }
    robots.content = "noindex, follow";
  }, []);

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center px-4 text-center">
      <p className="text-sm font-semibold uppercase tracking-wide text-gray-400">404</p>
      <h1 className="mt-3 text-2xl font-semibold text-gray-900 md:text-3xl">Page not found</h1>
      <p className="mt-2 max-w-md text-base text-gray-500">
        The page <span className="font-mono text-gray-600">{location.pathname}</span> is not available.
      </p>
      <Link
        to="/"
        className="mt-6 inline-flex rounded-full bg-[#2d6a4f] px-5 py-2.5 text-sm font-semibold text-white hover:bg-[#245a42]"
      >
        Back to home
      </Link>
    </div>
  );
}
